import * as React from "react";
import { Routes, Route } from "react-router-dom";
import Navbar from "./Components/Navbar";
import "./Homepage/Homepage.css";

const Homepage = React.lazy(() => import("./Homepage"));
const About = React.lazy(() => import("./About"));
const Sponsors = React.lazy(() => import("./sponsors"));
const ProjectsIndex = React.lazy(() => import("./Projects/ProjectsIndex"));
const ProjectDetail = React.lazy(() => import("./Projects/ProjectDetail"));
const OurTeam = React.lazy(() => import("./OurTeam"));
const JoinUs = React.lazy(() => import("./JoinUs"));

const DonateRedirect = () => {
  React.useEffect(() => {
    window.location.href = "https://www.uff.ufl.edu/giving-opportunities/027281-mae-liquid-propulsion/";
  }, []);
  return null;
};

function App() {
  return (
    <div>
      <a className="SkipLink" href="#main-content">Skip to main content</a>
      <Navbar />
      <React.Suspense fallback={null}>
        <Routes>
          <Route path="/" element={<Homepage />} />
          <Route path="/about" element={<About />} />
          <Route path="/projects" element={<ProjectsIndex />} />
          <Route path="/projects/:slug" element={<ProjectDetail />} />
          <Route path="/sponsors" element={<Sponsors />} />
          <Route path="/ourteam" element={<OurTeam />} />
          <Route path="/join-us" element={<JoinUs />} />
          <Route path="/donate" element={<DonateRedirect />} />
        </Routes>
      </React.Suspense>
    </div>
  );
}

export default App;
